// PwaInstallButton — DropPin v0.17.2
// ---------------------------------------------------------------------
// Small "Install" pill that appears in the header when the browser
// has fired beforeinstallprompt. Auto-hides once installed or if the
// browser never fires the event (Safari / already-installed / etc.).

import { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
import { theme } from '../theme';
import { showInstallPrompt } from '../pwa.js';

export default function PwaInstallButton() {
  const [available, setAvailable] = useState(
    typeof window !== 'undefined' && !!window._droppinInstallPrompt,
  );

  useEffect(() => {
    function onAvailable()  { setAvailable(true); }
    function onInstalled() { setAvailable(false); }
    window.addEventListener('droppin:installavailable', onAvailable);
    window.addEventListener('droppin:installed',        onInstalled);
    return () => {
      window.removeEventListener('droppin:installavailable', onAvailable);
      window.removeEventListener('droppin:installed',        onInstalled);
    };
  }, []);

  async function handleClick() {
    const outcome = await showInstallPrompt();
    if (outcome === 'accepted' || outcome === 'unavailable') {
      setAvailable(false);
    }
  }

  if (!available) return null;

  return (
    <button
      onClick={handleClick}
      title="Install DropPin to your device for offline access"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        padding: '4px 10px', fontSize: 12, fontWeight: 600,
        background: 'var(--brand-50, #fff7ed)',
        color: 'var(--brand-700, #c2510a)',
        border: '1px solid var(--brand-600, #e8650a)',
        borderRadius: 999,
        cursor: 'pointer',
        fontFamily: 'inherit',
      }}
    >
      <Download size={12} /> Install app
    </button>
  );
}
